import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { CountryDataForm, CountryFilters } from '../../../../app/models/Country';
import CountrySwitchChange from '../CountrySwitchChange';

interface Props {
    countries: CountryDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    destroy?: (id: number) => void;
    filter: CountryFilters;
    setFilter: (filter: CountryFilters) => void;
    callbackSuccess: () => void;
}

const CountryDataTable = ({
    countries,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: CountryDataForm) => <span>{row.id}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: CountryDataForm) => <span>{row.name}</span>
        },
        {
            name: 'Código',
            selector: (row: any) => row.code,
            sortable: true,
            sortField: 'code',
            cell: (row: CountryDataForm) => <span>{row.code ?? '-'}</span>
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: CountryDataForm) => (
                <CountrySwitchChange
                    countryId={row.id!}
                    checkValue={row.is_active ?? true}
                    callbackSuccess={callbackSuccess}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: CountryDataForm) => (
                <div>
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon="mdi mdi-pencil"
                            colorIcon="text-warning"
                            errorMessage="No se puede editar este registro."
                            title="Editar"
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon="mdi mdi-delete"
                            colorIcon="text-danger"
                            errorMessage="No se puede eliminar este registro."
                            title="Eliminar"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={countries}
            progressPending={loading}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default CountryDataTable;
